// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreLibrary = (client) => ({
    /**
     * `GET /store/library`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetStreamingLibrary
     * @source packages/medusa-plugin-streaming-media/src/api/store/library/route.ts
     */
    list: (query, headers) => client.fetch("/store/library", { method: "GET", query, headers }),
});
//# sourceMappingURL=library.js.map